export default __webpack_public_path__ + "static/media/default-monochrome-black.60f0b7ba.svg";